export enum PlayerColor {
  RED = 'red',
  GREEN = 'green',
  YELLOW = 'yellow',
  BLUE = 'blue',
}

export enum TokenState {
  HOME = 'home',
  ON_PATH = 'on_path',
  HOME_STRETCH = 'home_stretch',
  FINISHED = 'finished',
}

export enum GamePhase {
  MENU = 'menu',
  PLAYER_SELECT = 'player_select',
  PLAYING = 'playing',
  ANIMATING = 'animating',
  GAME_OVER = 'game_over',
}

export enum AIDifficulty {
  EASY = 'easy',
  NORMAL = 'normal',
  HARD = 'hard',
}

export type DiceValue = 1 | 2 | 3 | 4 | 5 | 6;

export interface TokenPosition {
  state: TokenState;
  pathIndex: number;
  stretchIndex: number;
}

export interface PlayerConfig {
  color: PlayerColor;
  name: string;
  isAI: boolean;
  aiDifficulty?: AIDifficulty;
}

export interface PlayerState {
  config: PlayerConfig;
  tokens: TokenPosition[];
  finishedCount: number;
  consecutiveSixes: number;
}

export interface Move {
  playerIndex: number;
  tokenIndex: number;
  from: TokenPosition;
  to: TokenPosition;
  isCapture: boolean;
  isFinished: boolean;
  diceValue: DiceValue;
}

export interface GameConfig {
  players: PlayerConfig[];
  maxPlayers: number;
}

export interface CellPosition {
  x: number;
  y: number;
}

export const PATH_LENGTH = 52;
export const STRETCH_LENGTH = 6;
export const TOKENS_PER_PLAYER = 4;
export const CONSECUTIVE_SIX_LIMIT = 3;

export const PLAYER_START_POSITIONS: Record<PlayerColor, number> = {
  [PlayerColor.RED]: 0,
  [PlayerColor.GREEN]: 13,
  [PlayerColor.YELLOW]: 26,
  [PlayerColor.BLUE]: 39,
};

// The junction cell (last shared path cell) from which each player turns
// into their home lane — start - 2, giving a classic 57-step journey
// (50 around the board + 6 lane cells + 1 into the center).
export const PLAYER_HOME_STRETCH_ENTRY: Record<PlayerColor, number> = {
  [PlayerColor.RED]: 50,
  [PlayerColor.GREEN]: 11,
  [PlayerColor.YELLOW]: 24,
  [PlayerColor.BLUE]: 37,
};

export const SAFE_POSITIONS: number[] = [0, 8, 13, 21, 26, 34, 39, 47];

export const PLAYER_COLORS: Record<PlayerColor, string> = {
  [PlayerColor.RED]: '#E74C3C',
  [PlayerColor.GREEN]: '#27AE60',
  [PlayerColor.YELLOW]: '#F1C40F',
  [PlayerColor.BLUE]: '#3498DB',
};

export const PLAYER_COLORS_LIGHT: Record<PlayerColor, string> = {
  [PlayerColor.RED]: '#FADBD8',
  [PlayerColor.GREEN]: '#D5F5E3',
  [PlayerColor.YELLOW]: '#FEF9E7',
  [PlayerColor.BLUE]: '#D6EAF8',
};

export const PLAYER_HOME_COORDS: Record<PlayerColor, { row: number; col: number }> = {
  [PlayerColor.RED]: { row: 2, col: 2 },
  [PlayerColor.GREEN]: { row: 2, col: 11 },
  [PlayerColor.YELLOW]: { row: 11, col: 11 },
  [PlayerColor.BLUE]: { row: 11, col: 2 },
};

export const PLAYER_ORDER: PlayerColor[] = [
  PlayerColor.RED,
  PlayerColor.GREEN,
  PlayerColor.YELLOW,
  PlayerColor.BLUE,
];
